import React from 'react';
import { PageLayout } from '../../components/shared/PageLayout';
import { Seo } from '../../components/shared/Seo';
import { HeroSection } from '../../components/shared/HeroSection';
import { FeatureGridSection } from '../../components/shared/FeatureGridSection';
import { StatsSection } from '../../components/shared/StatsSection';
import { CallToActionSection } from '../../components/shared/CallToActionSection';
import { BrandServicesSection } from './components/BrandServicesSection';

export const ServicesPage: React.FC = () => {
    const features = [
        { icon: 'ri-award-line', title: '10+ Years Experience', description: 'Over a decade of expertise in mobile device repair and customer service excellence.' },
        { icon: 'ri-shield-check-line', title: 'Genuine Parts Only', description: 'We use only authentic, brand-certified spare parts for all repairs to ensure quality.' },
        { icon: 'ri-time-line', title: 'Same-Day Service', description: 'Most repairs completed within the same day for your convenience and satisfaction.' },
        { icon: 'ri-customer-service-2-line', title: 'Expert Technicians', description: 'Certified and trained professionals with specialized knowledge of all major brands.' },
        { icon: 'ri-money-dollar-circle-line', title: 'Transparent Pricing', description: 'Clear, upfront pricing with no hidden charges. You know exactly what you pay.' },
        { icon: 'ri-truck-line', title: 'All-Kerala Courier', description: 'Convenient courier service available across Kerala for remote repair requests.' }
    ];

    const stats = [
        { number: '10+', label: 'Years Experience', icon: 'ri-calendar-line' },
        { number: '15,000+', label: 'Devices Repaired', icon: 'ri-smartphone-line' },
        { number: '98%', label: 'Success Rate', icon: 'ri-thumb-up-line' },
        { number: '24/7', label: 'Emergency Service', icon: 'ri-customer-service-2-line' }
    ];

    const structuredData = {
        "@context": "https://schema.org", "@type": "Service", "name": "Mobile Repair Services", "description": "Comprehensive mobile and laptop repair services for all major brands", "provider": { "@type": "LocalBusiness", "name": "Device Doctor", "address": { "@type": "PostalAddress", "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn", "addressLocality": "Kochi", "addressRegion": "Kerala", "postalCode": "682019", "addressCountry": "IN" }, "telephone": "+918714014140" }, "areaServed": "Kerala", "hasOfferCatalog": { "@type": "OfferCatalog", "name": "Mobile Repair Services", "itemListElement": [{ "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Screen Repair", "description": "Professional screen replacement for all mobile brands" } }] }
    };
    
    return (
        <PageLayout>
            <Seo
                title="Mobile Repair Services Kochi - iPhone, Samsung, Google Pixel | Device Doctor"
                description="Comprehensive mobile repair services in Kochi for iPhone, Samsung, Google Pixel, OnePlus, Vivo, Realme, Motorola. Screen repair, battery replacement, water damage repair. Same-day service available."
                keywords="mobile repair services kochi, phone repair kerala, iphone repair, samsung repair, google pixel repair, screen repair, battery replacement, water damage repair"
                structuredData={structuredData}
            />
            <h1 style={{ position: 'absolute', left: '-9999px' }}>Mobile Repair Services in Kochi - iPhone, Samsung, Google Pixel Repair</h1>
            
            <HeroSection
                title="Professional Mobile Repair Services"
                subtitle="Expert repair services for all major smartphone brands in Kochi. Genuine parts, certified technicians, and reliable solutions for your devices."
                backgroundImage="/assets/services-hero.jpg"
                className="bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700"
            />

            <BrandServicesSection />

            <FeatureGridSection
                title="Why Choose Device Doctor?"
                subtitle="With over 10 years of experience, we've built our reputation on quality, reliability, and exceptional customer service."
                badgeText="Our Commitment"
                features={features}
                theme="default"
            />
            
            <StatsSection
                title="Our Track Record Speaks"
                subtitle="Numbers that reflect our commitment to excellence and customer satisfaction."
                stats={stats}
            />
            
            <CallToActionSection
                title="Ready to Fix Your Device?"
                subtitle="Get your smartphone repaired by Kerala's most trusted mobile service experts. Contact Device Doctor today for professional repair services."
                themeColor="blue"
            />
        </PageLayout>
    );
};